import { render } from "./index.vue?vue&type=template&id=a2312062"
import script from "./index.ts?vue&type=script&lang=js"
export * from "./index.ts?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a2312062&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__